import React, { useState, useEffect } from 'react';
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField"; // Import Material-UI TextField
import Button from "@mui/material/Button"; // Import Material-UI Button
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid"; // Import Material-UI Grid
import { styled } from '@mui/material/styles'; // Import styled from Material-UI
import InputLabel from "@mui/material/InputLabel"; // Import Material-UI InputLabel

// Define custom styles using the `styled` function
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: '100%', // Default width for xs screen size
  [theme.breakpoints.up('sm')]: {
    width: '100%', // 60% width for sm screen size and larger
  },
  [theme.breakpoints.up('md')]: {
    width: '65%', // 40% width for md screen size and larger
  },
  [theme.breakpoints.up('lg')]: {
    width: '45%', // 30% width for lg screen size and larger
  },
}));

function PersonalInfoCard({ title, description, merchantData}) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  // console.log("Merchant Data", merchantData);

  const businessProfileObj = JSON.parse(
    merchantData?.merchantExt?.businessProfile || '{}'
  );
  const businessPhone = businessProfileObj.businessPhone;
  const businessEmail = merchantData?.merchantExt?.businessEmail;

  // useEffect(() => {
  //   const storedFirstName = localStorage.getItem('firstName');
  //   const storedLastName = localStorage.getItem('lastName');
  //   const storedEmail = localStorage.getItem('email');
  //   const storedPhoneNumber = localStorage.getItem('phone');

  //   if (storedFirstName) {
  //     setFirstName(merchantData.user.firstName);
  //   }

  //   if (storedLastName) {
  //     setLastName(merchantData.user.lastName);
  //   }

  //   if (storedEmail) {
  //     setEmail(merchantData.user.email);
  //   }

  //   if (storedPhoneNumber) {
  //     setPhoneNumber(merchantData.phone);
  //   }
  // }, []); // The empty dependency array ensures this effect runs once when the component mounts

  // Handle form submission
  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   // You can access individual form field values using the state variables
  //   console.log('First Name:', firstName);
  //   console.log('Last Name:', lastName);
  //   console.log('Email:', email);
  //   console.log('Phone Number:', phoneNumber);
  //   // Add logic for submitting the data to your server or performing other   // };

  return (
    <Card sx={{ height: "100%" }}>
      <SoftBox
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        pt={2}
        px={2}
      >
        <SoftTypography
          variant='h6'
          fontWeight='medium'
          textTransform='capitalize'
        >
          {title}
        </SoftTypography>
      </SoftBox>
      <SoftBox p={2}>
        <SoftBox mb={2} lineHeight={1}>
          <SoftTypography variant='button' color='text' fontWeight='regular'>
            {description}
          </SoftTypography>
        </SoftBox>
        <SoftBox opacity={0.3}>
          <Divider />
        </SoftBox>
        <SoftBox>
          {/* Form fields */}
          <form onSubmit={/*handleSubmit*/ (e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <InputLabel style={{ fontSize: "15px" }} htmlFor='first-name'>
                  First Name
                </InputLabel>
                <CustomTextField
                  id='first-name'
                  variant='outlined'
                  value={merchantData?.user?.firstName || "None Provided"}
                  // onChange={(e) => setFirstName(e.target.value)}
                  margin='normal'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputLabel style={{ fontSize: "15px" }} htmlFor='last-name'>
                  Last Name
                </InputLabel>
                <CustomTextField
                  id='last-name'
                  variant='outlined'
                  value={merchantData?.user?.lastName || "None Provided"}
                  // onChange={(e) => setLastName(e.target.value)}
                  margin='normal'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <InputLabel style={{ fontSize: "15px" }} htmlFor='email'>
                  Email
                </InputLabel>
                <CustomTextField
                  id='email'
                  variant='outlined'
                  value={merchantData?.user?.email || businessEmail || "None Provided"}
                  // onChange={(e) => setEmail(e.target.value)}
                  margin='normal'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputLabel style={{ fontSize: "15px" }} htmlFor='phone-number'>
                  Phone Number
                </InputLabel>
                <CustomTextField
                  id='phone-number'
                  variant='outlined'
                  value={
                    merchantData?.user?.phoneNumber ||
                    businessPhone ||
                    "None Provided"
                  }
                  // onChange={(e) => setPhoneNumber(e.target.value)}
                  margin='normal'
                  disabled
                />
              </Grid>
            </Grid>
          </form>
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

// Typechecking props for the ProfileInfoCard
PersonalInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  // PropTypes.shape({
  //   route: PropTypes.string.isRequired,
  //   tooltip: PropTypes.string.isRequired,
  // }).isRequired,
};

export default PersonalInfoCard;
